/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppFlavourModel } from '../../models/app-flavour-model';

export interface AdminAppFlavourPost$Params {
  
    /**
     * The app flavour data.
     */
    body?: AppFlavourModel
}

export function adminAppFlavourPost(http: HttpClient, rootUrl: string, params?: AdminAppFlavourPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<AppFlavourModel>> {
  const rb = new RequestBuilder(rootUrl, adminAppFlavourPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<AppFlavourModel>;
    })
  );
}

adminAppFlavourPost.PATH = '/Admin/AppFlavour';
